import { Component } from 'react'
import { Link } from 'react-router-dom'

/**
 * Catches render errors in route content so a single thrown value does not leave a blank screen.
 * Reset when `key` changes (e.g. card id) via parent.
 */
export default class RouteErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  render() {
    if (this.state.error) {
      return (
        <div className="page-container text-center py-20">
          <h1 className="text-2xl font-bold mb-4 text-white">This page could not be displayed</h1>
          <p className="text-gray-400 mb-6 text-sm max-w-md mx-auto">
            An error occurred while rendering this content. Try returning to the dashboard or
            reloading the page.
          </p>
          <Link to="/owner" className="btn-primary">
            Back to My Cards
          </Link>
        </div>
      )
    }
    return this.props.children
  }
}
